import React from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { Router, Route, Redirect } from 'react-router-dom';
import ReactExport from "react-data-export";
import history from '../../../../history';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';
import GuruEnt from '../../../../entity/Guru';
import {Link} from 'react-router-dom';
import KelasSearch from '../../../../entity/KelasSearch';
import AddGuru from './AddGuru';
import Loader from '../../../Loader';
import { CONFIG } from '../../../../config';
import __ from 'lodash';
import ListTabelGuru from './ListTabelGuru';

class Guru extends React.Component{
    constructor(props){
        super(props);
        this.state = {        
            isFetching: false,
            GuruEnt:[],
            searchGuru:'',
            isSearch: false,
            isEdit: false,
            idGuruSelected: ''
        }
        this.fetchGuru = this.fetchGuru.bind(this);
    }

    async componentDidMount(){
        document.title = "Guru";
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.fetchGuru();   
        }        
        
        this.setState({isFetching: false});
    }

    fetchGuru = async () =>{
        //fetch sekolah dulu
        const resFetchGuru = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_FETCH_GURU,{['idSekolah']:this.props.account.idSekolah}).catch(function(error){
        })

        if(resFetchGuru){
            if(resFetchGuru.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    GuruEnt: resFetchGuru.data.data
                })
            }
        }
        
        // this.state.GuruEnt.map((x, i) => {  
        //     const result = Object.values(x);  
        //     this.XX.push(result); 
        //  })
    }

    btnTambahGuru =() =>{
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        return(
            <div className="col-12 pull-left">
                <Link to={`/addGuru`}>
                    <button className="btn btn-primary">
                        <i className="fa fa-plus"> Guru</i>
                    </button>
                </Link>

                &nbsp;
                <ExcelFile element={<button className="btn btn-info" ><li className="fa fa-download"> Download Data</li></button>} filename= {"Guru "+this.props.account.namaUser} >
                    <ExcelSheet data={this.state.GuruEnt} name="Username Guru Sekolah">
                        <ExcelColumn label="Nama Guru" value="namaGuru"/>
                        <ExcelColumn label="Username" value="usernameGuru"/>
                        <ExcelColumn label="No. Hp" value="handphoneGuru"/>
                    </ExcelSheet>
                </ExcelFile>
                    

                <Router history={history}>
                    <Route path="/addGuru" exact component={AddGuru} />
                </Router> 
            </div>
        )
    }

    // cari guru
    searchGuru = async (search) =>{
        this.state.GuruEnt = '';
        this.setState({
            searchGuru:search.target.value
        })

        this.setState({isSearch:true})

        const fetchSearch = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_GURU,{
            ['idSekolah']:this.props.account.idSekolah,
            ['namaGuru']:search.target.value,
            ['usernameGuru']:search.target.value,
            ['emailGuru']:search.target.value,
            ['handphoneGuru']:search.target.value
        }).catch(function(error){
        })

        // simpan ke state list guru 
        if(fetchSearch){
            if(fetchSearch.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    GuruEnt: fetchSearch.data.data
                })
            }
        }
        this.setState({isSearch:false})
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }

    // aksi dari dropdown list guru
    dropdownGuruOnChange = async (idGuru) =>{
        const aksi =idGuru.split('-')[0];
        const id =idGuru.split('-')[1];

        // proses reset password
        if(aksi=="reset"){
            this.setState({isFetching: true});
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_RESET_PW_GURU, {...Guru, ["idGuru"]: id, ["idSekolah"]: this.props.account.idSekolah}).catch(function(error){
            });
            this.setState({isFetching: false});
            if(response.data.data.result){ 
                this.fetchGuru()
            }
            this.setState({isFetching:false})
        }else if(aksi=="edit"){
            // PROSES EDIT => lempar ke tampilan edit
            // console.log('edit');
            this.setState({idGuruSelected: id})
            this.setState({isEdit: true});
        }else if(aksi=="hapus"){
            this.setState({isFetching: true});
            // PROSES HAPUS AKUN
            if (window.confirm("Yakin Hapus ??")) {
                const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_HAPUS_GURU, {...Guru, ["idGuru"]: id, ["idSekolah"]: this.props.account.idSekolah}).catch(function(error){
                });
                this.setState({isFetching: false});
                if(response.data.data.result){
                    this.fetchGuru();  
                }
            }
            this.setState({isFetching:false})
        }else if(aksi=="isOn"){
            this.setState({isFetching: true});
            // PROSES MEMATIKAN STATUS GURU
            console.log('matikan');
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_CHANGE_STATUS_GURU, {...Guru,
                ["idGuru"]: id,
                ["idSekolah"]: this.props.account.idSekolah,
                ["statusGuru"]:1

            }).catch(function(error){});
            this.setState({isFetching: false});
            if(response.data.data.result){
                this.fetchGuru(); 
            }
        }else if(aksi=="isOff"){
            this.setState({isFetching: true});
            // PROSES MENGHIDUPKAN STATUS GURU
            console.log('Hidupkan');
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_CHANGE_STATUS_GURU, {...Guru,
                ["idGuru"]: id,
                ["idSekolah"]: this.props.account.idSekolah,
                ["statusGuru"]:0

            }).catch(function(error){});
            this.setState({isFetching: false});
            if(response.data.data.result){
                this.fetchGuru();  
            }
        }
    } 
    
    render(){
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar /> 
                    <h4>Management Guru</h4>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="pull-left">
                                {this.btnTambahGuru()}
                            </div>
                            <div className="pull-right">
                                <div className="col-md-4">
                                    <input value={this.state.searchGuru} onChange={this.searchGuru}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                        <br></br>
                        {this.loading()}
                        <div className="col-md-12">
                            <ListTabelGuru dataGuru={this.state.GuruEnt}  onChange={this.dropdownGuruOnChange}/>
                        </div>                        
                        {this.loading()}
                    </div>  
                </div>
            </div>
        )
    }

    // dataSet = [
    //     [ "Tiger Nixon", "System Architect", "Edinburgh", "5421", "2011/04/25", "$320,800" ],
    //     [ "Tiger Nixon", "System Architect", "Edinburgh", "5421", "2011/04/25", "$320,800" ],
    //     [ "Tiger Nixon", "System Architect", "Edinburgh", "5421", "2011/04/25", "$320,800" ]
    // ];
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Guru);